import {
    Component,
    computed,
    ElementRef,
    inject,
    OnDestroy,
    OnInit,
    Renderer2,
} from '@angular/core';
import { ToastComponent } from 'components/toaster/toast/toast.component';
import { ToastService } from 'services/toast.service';

@Component({
	selector: 'lbca-toaster',
	imports: [ToastComponent],
	templateUrl: './toaster.component.html',
	styleUrl: './toaster.component.scss',
})
export class ToasterComponent implements OnInit, OnDestroy {
	private readonly toastService = inject(ToastService);
	private readonly renderer = inject(Renderer2);
	private readonly elementRef = inject(ElementRef);

	public positions: { class: string; name: string; toasts: any[] }[] = [
		{
			class: 'position top left',
			name: 'top-left',
			toasts: [],
		},
		{
			class: 'position top center',
			name: 'top-center',
			toasts: [],
		},
		{
			class: 'position top right',
			name: 'top-right',
			toasts: [],
		},
		{
			class: 'position bottom left',
			name: 'bottom-left',
			toasts: [],
		},
		{
			class: 'position bottom center',
			name: 'bottom-center',
			toasts: [],
		},
		{
			class: 'position bottom right',
			name: 'bottom-right',
			toasts: [],
		},
	];

	public toastsByPosition = computed(() => {
		const toasts = this.toastService.toasts();
		const positions = this.positions;

		positions.forEach((position) => {
			position.toasts = toasts.filter((toast) => toast.position === position.name);
		});

		return positions;
	});

	ngOnInit() {
		const nativeElement = this.elementRef.nativeElement;
		this.renderer.appendChild(document.body, nativeElement);
	}
	ngOnDestroy() {
		const nativeElement = this.elementRef.nativeElement;
		this.renderer.removeChild(document.body, nativeElement);
	}

	removeToast(index: number) {
		this.toastService.remove(index);
	}
}
